import * as types from '../actionTypes/Checklist'

export const setChecklistStatus = payload => ({
    type: types.SET_CHECKLIST_STATE,
    payload,
})

export const setChecklistError = payload => ({
    type: types.SET_CHECKLIST_ERROR,
    payload,
})

export const setChecklistStep = payload => ({
    type: types.SET_CHECKLIST_STEP,
    payload,
})
